/* eslint-disable no-unused-expressions */
import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
// import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useDevice } from '../../hooks/useResponsive';

function ChallanFailPage() {
  // const { state } = location;
  const { isMobile } = useDevice();
  const navigate = useNavigate();

  // console.log(state);

  const handleGoBack = () => {
    navigate('/challan/all'); // ✅ Change this to your desired route
  };

  return (
    <Box
      sx={{
        minHeight: '80vh',
        backgroundColor: '#121212',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Stack
        spacing={4}
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: '#1e1e1e',
          borderRadius: 4,
          padding: isMobile ? 4 : 6,
          // boxShadow: '0 0 20px rgba(255, 0, 0, 0.2)',
          maxWidth: 500,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 80, color: '#FF4C4C' }} />

        <Typography variant={isMobile ? 'h5' : 'h4'} color="#FF4C4C" fontWeight={700}>
          Payment Failed
        </Typography>

        <Typography variant="body1" color="gray">
          Oops! Something went wrong with your transaction. Please try again later or contact support if the issue
          persists.
        </Typography>

        <Button
          variant="contained"
          onClick={handleGoBack}
          sx={{
            boxShadow: 'unset',
            color: '#fff',
            textTransform: 'none',
            backgroundColor: '#F8971C',

            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#e57f00',
            },
          }}
        >
          Go Back
        </Button>
      </Stack>
    </Box>
  );
}

export default ChallanFailPage;
